import { render } from "./appointmentTable.vue?vue&type=template&id=301d3f4c"
import script from "./appointmentTable.vue?vue&type=script&lang=js"
export * from "./appointmentTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__